module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    class: ['stage-arrow', {
      'macos': _vm.isMac
    }]
  }, [_c('span', {
    class: [_vm.result.type, _vm.result.direction]
  }, [_c('span', [_vm._v(_vm._s(_vm.arrowText))])])]), _vm._v(" "), _c('div', {
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.feedback))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), (_vm.status === 'playing') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "transparent",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790cf253"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flanker.vue
// module id = 167
// module chunks = 1